/*
 * Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const SPACE_CODE = 32;
const DELETE_CODE = 127;

/** These routes are served by a separate Next application, outside Studio SPA. */
export function isFrontendLoginRedirect(target: string): boolean {
  return /^\/(app|notebooks|agents|chats|workspace)(\/|\?|#|$)/.test(target);
}

export function navigateFrontendLoginRedirect(target: string): void {
  window.location.assign(target);
}

/** Accept only root-relative return paths, never an external URL. */
export function resolveLoginRedirect(raw: string | null | undefined): string {
  if (
    !raw?.startsWith('/') ||
    raw.startsWith('//') ||
    raw.includes('\\') ||
    Array.from(raw).some(
      char =>
        char.charCodeAt(0) <= SPACE_CODE || char.charCodeAt(0) === DELETE_CODE,
    )
  ) {
    return '/';
  }

  try {
    const base = 'https://redirect.invalid';
    const target = new URL(raw, base);
    // Dot-segment normalization can turn /app/..//host into //host.
    if (target.origin !== base || target.pathname.startsWith('//')) {
      return '/';
    }
    return `${target.pathname}${target.search}${target.hash}`;
    // eslint-disable-next-line @coze-arch/use-error-in-catch -- Invalid return URLs fail closed.
  } catch {
    return '/';
  }
}
